import * as React from "react";
import { SubmitButtonProps } from "./typings";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({ colSpan, lobState }) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <div>
        <UitkPrimaryButton
          tag="button"
          type="submit"
          text={formatText(lobState.config.form.submitButton.locToken)}
          size={UitkButtonSize.LARGE}
          isFullWidth={true}
        />
      </div>
    </UitkLayoutGridItem>
  );
};
